export default __webpack_public_path__ + "static/media/ledred.bd63140a.png";